import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DatePipe } from '@angular/common';
import { AngularMaterialModule } from './angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AuthModule } from './auth/auth.module';
import { PageModule } from './page/page.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorCustom } from './utiles/CustomPaginator';
import { TokenInterceptorService } from './services/token-interceptor.service';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { CustomDateAdapter } from './utiles/dateformat';
import { FormSolicitudComponent } from './components/form-solicitud/form-solicitud.component';
import { AyudaAtajoModalComponent } from './components/modales_atajos/ayuda-atajo-modal/ayuda-atajo-modal.component';
import { UpdateSolicitudModalComponent } from './components/update-solicitud-modal/update-solicitud-modal.component';
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent, FormSolicitudComponent, AyudaAtajoModalComponent, UpdateSolicitudModalComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PageModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MatPaginatorIntl, useClass: MatPaginatorCustom },
    { provide: DateAdapter, useClass: CustomDateAdapter },

    DatePipe,
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
